import VSelect from './VSelect'

export { VSelect }
export default VSelect
